module.exports = __webpack_public_path__ + "img/bronze-crown.fc1efd2f.svg";